import { Stack } from '@mui/material'
import { FC } from 'react'
import ActiveStatus from '../../../assets/images/icons/camera-status-active-icon.svg?react'
import WarningStatus from '../../../assets/images/icons/camera-status-warning-icon.svg?react'
import UnenrolledStatus from '../../../assets/images/icons/camera-status-unenrolled-icon.svg?react'
import { BadgeStatus } from './cameraOverviewEnums'

interface CameraCardStatusBadgeProps {
  status: BadgeStatus
}

const ERROR_BADGE_STATUSES: BadgeStatus[] = [
  BadgeStatus.Unenrolled,
  BadgeStatus.PreviouslyUnenrolled,
  BadgeStatus.UnenrollFailed,
  BadgeStatus.WarnFailed
]

const WARNING_BADGE_STATUSES: BadgeStatus[] = [BadgeStatus.Warned, BadgeStatus.WarnedFirst, BadgeStatus.WarnedFinal]

const WARNING_ICON_STATUSES: BadgeStatus[] = [
  ...WARNING_BADGE_STATUSES,
  BadgeStatus.PreviouslyUnenrolled,
  BadgeStatus.UnenrollFailed,
  BadgeStatus.WarnFailed
]

export const CameraCardStatusBadge: FC<CameraCardStatusBadgeProps> = ({ status }) => {
  const getStatusIcon = () => {
    if (WARNING_ICON_STATUSES.includes(status)) return <WarningStatus />
    if (ERROR_BADGE_STATUSES.includes(status)) return <UnenrolledStatus />
    return <ActiveStatus />
  }

  const getStatusColor = () => {
    if (ERROR_BADGE_STATUSES.includes(status)) return 'var(--shape-error)'
    if (WARNING_BADGE_STATUSES.includes(status)) return 'var(--shape-warning)'
    return 'var(--shape-confirm)'
  }

  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '6px',
        gap: '8px',
        height: '24px',
        backgroundColor: getStatusColor(),
        borderRadius: '8px',
        color: 'white'
      }}
      data-testid="camera-card-status-badge"
    >
      {getStatusIcon()}
      {status}
    </Stack>
  )
}
